<template>
  <section class="adm-card" :class="{ 'adm-card--flush': flush }">
    <header v-if="title || $slots.header || $slots.actions" class="adm-card__head">
      <div class="adm-card__titles">
        <slot name="header">
          <h3 class="adm-subtitle">{{ title }}</h3>
          <p v-if="subtitle" class="adm-muted adm-card__subtitle">{{ subtitle }}</p>
        </slot>
      </div>
      <div v-if="$slots.actions" class="adm-card__actions">
        <slot name="actions" />
      </div>
    </header>

    <div class="adm-card__body">
      <slot />
    </div>

    <footer v-if="$slots.footer" class="adm-card__foot">
      <slot name="footer" />
    </footer>
  </section>
</template>

<script>
/** Tarjeta de sección del panel — plan 27_09_2026 §4.2. */
export default {
  name: 'AdmCard',
  props: {
    title: { type: String, default: '' },
    subtitle: { type: String, default: '' },
    /** Sin relleno en el cuerpo: para tablas que llegan al borde. */
    flush: { type: Boolean, default: false },
  },
};
</script>

<style scoped>
.adm-card {
  display: flex;
  flex-direction: column;
  background-color: var(--adm-surface);
  border: 1px solid var(--adm-border);
  border-radius: var(--adm-radius);
  box-shadow: var(--adm-shadow);
  /* NO poner `overflow: hidden` aquí: recortaría los desplegables que se
     abren dentro de la tarjeta (los `multiselect` de Dashboard y Gastos
     quedaban cortados en el borde). El redondeo de las esquinas inferiores
     lo resuelve el propio pie con su `border-radius`. */
  overflow: visible;
}

.adm-card__head {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  gap: var(--adm-gap);
  flex-wrap: wrap;
  padding: var(--adm-gap) var(--adm-gap-lg);
  border-bottom: 1px solid var(--adm-border);
}

.adm-card__titles { min-width: 0; }
.adm-card__subtitle { margin: 0.2rem 0 0 0; }

.adm-card__actions {
  display: flex;
  align-items: center;
  gap: var(--adm-gap-sm);
  flex-wrap: wrap;
}

.adm-card__body { padding: var(--adm-gap-lg); }

.adm-card--flush .adm-card__body { padding: 0; }

/* La variante `flush` sí recorta: aloja tablas que llegan al borde y deben
   quedar dentro del radio de la tarjeta. No contiene capas flotantes. */
.adm-card--flush { overflow: hidden; }

.adm-card__foot {
  display: flex;
  align-items: center;
  justify-content: flex-end;
  gap: var(--adm-gap-sm);
  padding: var(--adm-gap) var(--adm-gap-lg);
  border-top: 1px solid var(--adm-border);
  background-color: var(--adm-surface-alt);
  /* Sin el recorte de la tarjeta, el fondo del pie asomaría por fuera de las
     esquinas redondeadas. */
  border-radius: 0 0 calc(var(--adm-radius) - 1px) calc(var(--adm-radius) - 1px);
}
</style>
